import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class RulesAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  createSuccess() {
    const message = {
      body: 'RULE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'RULE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateSuccess() {
    const message = {
      body: 'RULE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'RULE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteSuccess() {
    const message = {
      body: 'RULE_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'RULE_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .service('rulesAlertsService', RulesAlertsService);
